import {useState} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';

import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';

import * as snackbarsActions from '../../../../../../actions/snackbars';
import documentService from '../../../../../../services/document/DocumentService';
import {captureError} from '../../../../../../utils/log';
import {AUTO_GENERATE_FILE_DOCUMENT_TYPE} from '../../../../../../utils/constant';
import signatureService from '../../../../../../services/signature/SignatureService';

import UploadPanel from '../../../../../document/UploadPanel';
import ModalWaitingSignature from '../../../../../document/ModalWaitingSignature';

import {useCustomStore} from '../../DepositorSectionStore';

import DocumentView from './DocumentView';

function DocumentContainer({document}) {
  const organisationId = useSelector(globalState => globalState.organisation.organisationId);
  const globalDispatch = useDispatch();
  const {dispatch} = useCustomStore();
  const [isSignatureModalOpen, setIsSignatureModalOpen] = useState(false);

  let triggerUpload = () => { /* placeholder function */ };

  function handleSignDocument(documentId) {
    setIsSignatureModalOpen(true);
    signatureService.signDocument(documentId)
      .then(response => window.open(response.url, '_self'))
      .catch(error => {
        captureError('Error while trying to sign a document on dashboard', error);
        globalDispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
        setIsSignatureModalOpen(false);
      });
  }

  function handleAction() {
    if (document.state === DOCUMENT_STATE.AWAITING_SIGNATURE) {
      return handleSignDocument(document.uid);
    }

    if (document.type.code === AUTO_GENERATE_FILE_DOCUMENT_TYPE) {
      return documentService.getNewVersionToSign(document.uid)
        .then(newVersion => handleSignDocument(newVersion.uid))
        .catch(error => {
          captureError('Error while getting new ADD_SWORN_STAT version to sign', error);
          globalDispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
        });
    }

    return triggerUpload(document);
  }

  function handleUploadSubmit() {
    window.dispatchEvent(new Event('decrementDocumentCount'));
    dispatch({type: 'FETCH_DOCUMENTS'});
  }

  return (
    <>
      <DocumentView
        document={document}
        onActionClick={handleAction}
      />

      <ModalWaitingSignature isOpen={isSignatureModalOpen}/>

      <UploadPanel
        organisationId={organisationId}
        setUploadTrigger={uploadFunction => {
          triggerUpload = uploadFunction;
        }}
        onUploadSuccess={handleUploadSubmit}
        refreshDocuments={handleUploadSubmit}
        displaySuccessNotification={false}
      />
    </>
  );
}

DocumentContainer.propTypes = {
  document: PropTypes.object.isRequired
};

export default DocumentContainer;
